import { render, staticRenderFns } from "./PublisherProfilesTables.vue?vue&type=template&id=04923b72&"
import script from "./PublisherProfilesTables.vue?vue&type=script&lang=js&"
export * from "./PublisherProfilesTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports